import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouteConfigLoadEnd, Router } from '@angular/router';
import { MessageUtils } from '@app/MessageUtils';
import { User } from '@app/models/User';
import { UserService } from '@app/services/user/user.service';
import { AppService, LocalStorageService, SessionStorageService } from '@mova/components/core';

@Component({
  selector: 'app-verificar-usuario',
  templateUrl: './verificar-usuario.component.html',
  styleUrls: ['./verificar-usuario.component.scss']
})
export class VerificarUsuarioComponent implements OnInit {

  private user:User;
  private cdNifNie:String;
  private cdMailUniversidad:String;

  constructor(private _userService:UserService, private activateRoute: ActivatedRoute,
    private _sessionStorageService:SessionStorageService,
    private router:Router, private _appService: AppService) {}

  ngOnInit(): void {
    let cdNifNie = this.activateRoute.snapshot.params['cdNifNie'];
    let cdMailUniversidad = this.activateRoute.snapshot.params['cdMailUniversidad'];
    this._userService.verificaUsuario(cdNifNie, cdMailUniversidad).subscribe((res:any) => {
      this.user = res.data.data;

      this._sessionStorageService.setItem(MessageUtils.DATA_USER, this.user);
      this.router.navigate(['datos-usuario']);
    }, (error) => {
      this._sessionStorageService.setItem(MessageUtils.LINK_AVAILABLE, 'false');
      this.router.navigate(["login-view"]);
    });

  }

}
